import { createContext } from "react";

export const SimpleMapContext = createContext<google.maps.Map | null>(null);

export const ZoomContext = createContext<{ zoom: number }>({ zoom: 0 });